var map = {
	"./bg-description.png": 28,
	"./bg-main.png": 29,
	"./dummy/about.png": 30,
	"./dummy/description.png": 31,
	"./dummy/main.png": 32,
	"./logo/gampla_logo.png": 33,
	"./logo/gampla_purple.png": 34,
	"./logo/logo.png": 35,
	"./logo/sns/facebook.png": 36,
	"./logo/sns/line.png": 37,
	"./logo/sns/twitter.png": 38,
	"./logo/sns/x.png": 39,
	"./mamari/wowma/about-bg.png": 40,
	"./mamari/wowma/about-img-01.png": 41,
	"./mamari/wowma/about-title.png": 42,
	"./mamari/wowma/about-wowma.png": 43,
	"./mamari/wowma/attention.png": 44,
	"./mamari/wowma/btn-already-yellow.png": 45,
	"./mamari/wowma/btn-already.png": 46,
	"./mamari/wowma/btn-apply-yellow.png": 47,
	"./mamari/wowma/btn-apply.png": 48,
	"./mamari/wowma/btn-download-yellow.png": 49,
	"./mamari/wowma/btn-download.png": 50,
	"./mamari/wowma/flow-bg-green.png": 51,
	"./mamari/wowma/flow-bg-pink.png": 19,
	"./mamari/wowma/flow-bg-red.png": 52,
	"./mamari/wowma/header-logo.png": 23,
	"./mamari/wowma/icon-arrow-next.png": 53,
	"./mamari/wowma/require-brown.png": 54,
	"./mamari/wowma/require-green.png": 55,
	"./notfound_image.png": 56
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27;